/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from 'react';
import { useResponsive } from '@aibees/shared/hooks';
import { RenderMode } from '../types';

interface Refs {
  childrenRef: React.RefObject<HTMLDivElement>;
  containerRef: React.RefObject<HTMLDivElement>;
  inputRef: React.RefObject<HTMLDivElement>;
}

export function useDropDownConfig(refs: Refs, renderMode: RenderMode) {
  const { childrenRef, containerRef, inputRef } = refs;

  const lgDown = useResponsive('down', 'xxl');
  const additionalPadding = 8;
  const [width, setWidth] = useState<string>('100%');

  const calculateWidth = useCallback(
    (
      refsArray: React.RefObject<HTMLDivElement>[],
      additionalWidth = 0
    ): string => {
      const totalWidth = refsArray.reduce((sum, ref) => {
        return ref.current ? sum + ref.current.offsetWidth : sum;
      }, 0);
      return `${totalWidth + additionalWidth}px` || '100%';
    },
    []
  );

  useEffect(() => {
    if (renderMode === 'dialog') {
      setWidth(calculateWidth([containerRef]));
    } else if (lgDown) {
      setWidth(calculateWidth([inputRef, childrenRef], 8));
    } else {
      setWidth(calculateWidth([inputRef]));
    }
  }, [
    childrenRef,
    inputRef,
    containerRef,
    renderMode,
    lgDown,
    additionalPadding,
  ]);
  return { width };
}
